export enum PROJECT_STATUS {
  INACTIVE = "INACTIVE",
  ACTIVE = "ACTIVE",
  INPROGRESS = "INPROGRESS",
  FAILED = "FAILED",
  PENDING = "PENDING",
  CANCELLED = "CANCELLED",
  PAYMENT = "PAYMENT DUE",
}

export enum DatabaseEngine {
  MySQL = "mysql",
  PostgreSQL = "postgresql",
  MongoDB = "mongodb",
  Redis = "redis",
  Neo4j = "neo4j",
  WordPress = "wordpress",
  SQLite = "sqlite",
  RabbitMQ = "rabbitmq",
}

export enum ApplicationLogsStatus {
  LIVE = "live stream",
  PAUSE = "pause",
  RESUME = "resume",
}

export enum GitType {
  GitHub = "github",
  GitLab = "gitlab",
  Bitbucket = "bitbucket",
  Docker = "docker",
}

export enum ServiceType {
  WebService = "web-service",
  Database = "database",
  Worker = "worker",
  Mcp = "mcp",
}
